/**
 * InfoPackOverlay.
 * @author Dayne Coulson-Hoffacker
 */
export default class InfoPackOverlay {
  /**
   * Constructs a new InfoPackOverlay component.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor (options) {
    this.element = options.element
    this.infoPackOverlayToggle = document.querySelector('[data-component="info-pack-overlay-toggle"]')
    this.closeBtn = this.element.querySelector('[data-component="close-btn"]')

    this.infoPackOverlayToggle.addEventListener('click', () => {
      this.element.classList.add('visible')
    })

    this.closeBtn.addEventListener('click', () => {
      this.element.classList.remove('visible')
    })

  }

}



// WEBPACK FOOTER //
// ./components/events/info-pack-overlay/index.js